import { Plus } from "lucide-react"
import emptyImage from '../images/empty-state.png'

export default function EmptyState({ heading, subhead, buttonText, size, onClickProperty }) {
  return (
    <div className="p-6">
        <div className="max-w-2xl mx-auto">
            <div className="mb-2 w-full">
                <img
                  src={emptyImage}
                  alt="No data available"
                  className={`mx-auto opacity-80${size === "sm" ? " h-36" : ""}`}
                />
            </div>

            <div className="text-center">
                <h2 className="text-base font-semiboldx text-gray-700 mb-2">{heading}.</h2>
                <p className="text-gray-400 text-sm mb-8">{subhead}</p>
                {buttonText && (
                    <button
                        onClick={onClickProperty}
                        className="btn btn-primary text-sm"
                    >
                        <Plus className="w-5 h-5 mr-2" />
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    </div>
  )
}
